var _circle, _circle2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountManagerIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23,
    stroke: "#322F61",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#322F61"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3770_26776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3182 20.25C25.3182 18.4544 23.8536 17 22.0455 17C20.2373 17 18.7727 18.4544 18.7727 20.25C18.7727 22.0456 20.2373 23.5 22.0455 23.5C23.8536 23.5 25.3182 22.0456 25.3182 20.25ZM23.6818 20.25C23.6818 21.1438 22.9455 21.875 22.0455 21.875C21.1455 21.875 20.4091 21.1438 20.4091 20.25C20.4091 19.3562 21.1455 18.625 22.0455 18.625C22.9455 18.625 23.6818 19.3562 23.6818 20.25ZM15.5 28.375V30H28.5909V28.375C28.5909 26.2137 24.23 25.125 22.0455 25.125C19.8609 25.125 15.5 26.2137 15.5 28.375ZM17.1364 28.375C17.3 27.7981 19.8364 26.75 22.0455 26.75C24.2464 26.75 26.7745 27.79 26.9545 28.375H17.1364ZM31.0455 25.9375V23.5H33.5V21.875H31.0455V19.4375H29.4091V21.875H26.9545V23.5H29.4091V25.9375H31.0455Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3770_26776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountManagerIcon);
export default __webpack_public_path__ + "static/media/account-manager-icon.63fc8adae180de4bdf52d5a8ca2a79f7.svg";
export { ForwardRef as ReactComponent };